import { render, staticRenderFns } from "./NuevoNomina.vue?vue&type=template&id=112eb0eb&"
import script from "./NuevoNomina.vue?vue&type=script&lang=js&"
export * from "./NuevoNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports